import { BtnSesame } from './BtnSesame';

export class BtnRoundelFramed extends Phaser.GameObjects.Container {
  constructor(
    scene,
    x,
    y,
    {
      id,
      active,
      thumbSheet,
      thumbKey,
      frame = 'btn_frame_white',
      showCheck = false,
      hoverVO,
      enabled,
    }
  ) {
    super(scene, x, y);
    scene.add.existing(this);
    this.id = id;
    this.active = active;
    this.hoverVO = hoverVO;
    this.thumb = scene.add.image(0, 0, thumbSheet, thumbKey);
    this.frame = new BtnSesame(scene, {
      sheet: 'buttons',
      costume: frame,
      y: 5,
      enabled: false,
      clickSFX: 'sfx_ui_btn',
    });
    this.add([this.thumb, this.frame]);

    if (showCheck) {
      this.add(scene.add.image(0, this.frame.height * 0.48, 'buttons', 'btn_check'));
    }

    if (enabled) this.enable();
  }

  enable() {
    if (this.frame.buttonEnabled) return;
    this.frame.on('click', () => {
      if (this._emitting) return;
      this._emitting = true;
      this._emitClick();
      if (this.frame._clickSFX) {
        this.scene.game.soundController.playSFX('sfx', this.frame._clickSFX);
      }
      console.log('IS VO PLAYING : ', this.scene.game.vo.voIsPlaying(this.hoverVO));
      if (this.scene.game.vo.voIsPlaying(this.hoverVO)) {
        this.scene.game.vo.off('vocomplete', this._emitVoComplete, this);
        this.scene.game.vo.once('vocomplete', this._emitVoComplete, this);
      } else if (this.scene.game.vo.voWasLastPlayed(this.hoverVO)) {
        this._emitVoComplete();
      } else {
        this.scene.game.vo.play(this.hoverVO, { onComplete: this._emitVoComplete.bind(this) });
      }
    });
    this.frame.enable();
    if (this.hoverVO) {
      this.frame.on('pointerover', this.playHoverVo, this);
    }
  }

  _emitClick(event) {
    this.emit('click', this.id);
  }

  _emitVoComplete() {
    this.scene.game.vo.off('vocomplete', this._emitClick, this);
    this.emit('vocomplete', this.id);
    this._emitting = false;
  }

  disable() {
    this.frame.removeAllListeners('click');
    this.frame.off('pointerover', this.playHoverVo, this);
    this.frame.disable();
  }

  playHoverVo() {
    if (this.scene.game.device.os.desktop) this.scene.game.vo.play(this.hoverVO, { priority: -1 });
  }

  destroy() {
    this.scene.game.vo.off('vocomplete', this._emitClick, this);
    super.destroy();
  }
}

BtnRoundelFramed.FRAME = {
  WHITE: 'btn_frame_white',
  GOLD: 'btn_frame_gold',
};
